import React from "react";

function CenteredMessage(props: any){
    return (<div className="centeredMessage">
        {props.children}
    </div>)
}

export default CenteredMessage;